import axios from 'axios'
import { loadingService } from '@/utils/loadingService'
import { toastService } from '@/utils/toastService'
import i18n from '@/i18n'
import store from '@/store'
import { localeToRegionIdMap, uniteTenementId } from '@/config/const'
import { errorCodeMap } from '@/config/const'

const makeErrorMessage = (errorCode) => {
  const errorMessage = errorCodeMap[errorCode]
  if (!errorMessage) {
    return i18n.global.t('api.serverError') + errorCode
  }
  return i18n.global.t(errorMessage)
}


const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
})

instance.interceptors.request.use(config => {
  if (config.url !== '/json/web/queryWebOrderById') {
    loadingService.show()
  }
  const locale = store.state.locale
  const { method, data = {}, params = {} } = config
  const baseParams = {
    req: {
      regionId: localeToRegionIdMap[locale],
      uniteTenementId
    }
  }
  if (method === 'post') {
    const mergeParams = {
      req: {
        ...baseParams.req,
        ...data
      }
    }
    config.data = mergeParams
  } else if (method === 'get') {
    const mergeParams = {
      req: {
        ...baseParams.req,
        ...params
      }
    }
    config.params = mergeParams
  }
  return config
}, error => {
  toastService.show('request error')
  if (error.config.url !== '/json/web/queryWebOrderById') {
    loadingService.hide()
  }
  return Promise.reject(error)
})

instance.interceptors.response.use(response => {
  if (response.config.url !== '/json/web/queryWebOrderById') {
    loadingService.hide()
  }
  if (response.status === 200) {
    if (response.data.tars_ret === 0) {
      return response.data.data
    } else {
      toastService.show(makeErrorMessage(response.data.tars_ret))
      return Promise.reject(response.data)
    }
  } else {
    toastService.show(i18n.global.t('api.networkError'))
    return Promise.reject(response.data)
  }
}, error => {
  // const { t, locale } = i18n.global
  // console.log(locale, 'locale')
  toastService.show(i18n.global.t('api.networkError'))
  if (error.config.url !== '/json/web/queryWebOrderById') {
    loadingService.hide()
  }
  return Promise.reject(error)
})

export default instance
